import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { SearchBarContext } from '../../../../components/SearchBar';
import SearchBarRow from '../../../../components/SearchBar/SearchBarRow';

const PrimarySearchItems = (props) => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'departments.search.name-field' })}</label>
        <input className="form-control" {...register('name')}></input>
      </div>
    </SearchBarRow>
  );
};

PrimarySearchItems.propTypes = {
};

export { PrimarySearchItems };
